import { render } from "./LoadingOverlay.vue?vue&type=template&id=179699f4&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=179699f4&scoped=true&lang=css"

import exportComponent from "/var/www/hrm-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179699f4"]])

export default __exports__